import React, { useState } from 'react';
import { TermsModal, PrivacyModal } from './LegalModals';
export function Footer() {
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  return <>
      <footer className="bg-warm-white py-12 border-t border-beige" data-id="element-83">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-84">
          <div className="font-serif text-2xl font-bold text-espresso tracking-tight" data-id="element-85">
            Masa Pan<span className="text-terracotta" data-id="element-86">.</span>
          </div>

          <div className="text-espresso/60 text-sm text-center md:text-left" data-id="element-87">
            &copy; {new Date().getFullYear()} Masa Pan. Todos los derechos
            reservados.
          </div>

          <div className="flex gap-6 text-sm text-espresso/70" data-id="element-88">
            <button onClick={() => setIsTermsOpen(true)} className="hover:text-terracotta transition-colors" data-id="element-89">
              Términos
            </button>
            <button onClick={() => setIsPrivacyOpen(true)} className="hover:text-terracotta transition-colors" data-id="element-90">
              Privacidad
            </button>
            <a href="mailto:soporte@masapan.com" className="hover:text-terracotta transition-colors" data-id="element-91">
              Contacto
            </a>
          </div>
        </div>
      </footer>

      <TermsModal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} data-id="element-92" />
      <PrivacyModal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} data-id="element-93" />
    </>;
}